import { DogBreederApplicationExperienceLimited } from '@application/types';
import { enumSelectOptions } from '@application/utils';
import type { DogBreederApplicationExperience } from '@gql/graphql';
import { DogBreederApplicationTimeAlone, DogBreederApplicationTrainer } from '@gql/graphql';
import { InputLabel, InputRadioField, InputWrapper, Section } from '@presentation/components';
import { useTranslation } from '@presentation/utils';

export const PuppyCare = () => {
  const { translate } = useTranslation();
  const { translate: translateRessource } = useTranslation({
    keyPrefix: 'common.inputs',
  });

  return (
    <>
      <Section>
        <InputLabel required size="big">
          {translateRessource('experiences.label')}
        </InputLabel>
        <InputWrapper>
          <InputRadioField<DogBreederApplicationExperience[]>
            name="experiences"
            separated
            options={enumSelectOptions(
              translate,
              'enum.dogBreederApplicationExperience',
              DogBreederApplicationExperienceLimited,
            )}
          />
        </InputWrapper>
      </Section>

      <Section>
        <InputLabel required size="big">
          {translateRessource('timeAlone.label')}
        </InputLabel>
        <InputWrapper>
          <InputRadioField<DogBreederApplicationTimeAlone>
            name="timeAlone"
            separated
            options={enumSelectOptions(
              translate,
              'enum.dogBreederApplicationTimeAlone',
              DogBreederApplicationTimeAlone,
            )}
          />
        </InputWrapper>
      </Section>

      <Section>
        <InputLabel required size="big">
          {translateRessource('trainers.label')}
        </InputLabel>
        <InputWrapper>
          <InputRadioField<DogBreederApplicationTrainer>
            name="trainers"
            separated
            multiple
            options={enumSelectOptions(
              translate,
              'enum.dogBreederApplicationTrainer',
              DogBreederApplicationTrainer,
            )}
          />
        </InputWrapper>
      </Section>
    </>
  );
};
